import VmFinanceComponent from "../../components/productsInfosComponents/FinanceComponnents/vmFinanceComponent";

const FinanceComponentPage=({vmIds,vmNames})=>{
    return (
        <VmFinanceComponent vmIds={vmIds} vmNames={vmNames}/>
    );
};

export default FinanceComponentPage;